import { useSelector } from 'react-redux';

import { emptyArray } from 'ui-components/default-props/empty';

import Global from '../../store/global-selectors';

export const useIsShipperHqEnabledForStore = (storeGuid) => {
  const shipperHQConnectedStoreGuids = useSelector(Global.selectSellerShipperHQConnectedStoreGuids) || emptyArray;
  return shipperHQConnectedStoreGuids.includes(storeGuid);
};
